"use strict";

exports.__esModule = true;
exports.SymbolSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SymbolSelector = exports.SymbolSelector = function SymbolSelector(props) {
  var _chartItem$symbol, _chartItem$symbol2, _chartItem$symbol3;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem,
    showSymbolOption = props.showSymbolOption;
  var symbol = chartItem == null ? void 0 : chartItem.symbol;
  var defaultSymbolSize = 4;
  var defaultSymbolType = _constants.SYMBOL_CIRCLE;
  (0, _react.useEffect)(function () {
    if (!symbol || Object.entries(symbol).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].symbol",
          value: el.props.chartItems.props[itemIndex].symbol = {
            show: false,
            size: defaultSymbolSize,
            type: defaultSymbolType
          }
        };
      });
    }
  }, [symbol, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "SymbolSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("SymbolSelector.symbolOptions.label", "Symbol options")), showSymbolOption && /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("SymbolSelector.symbolShow.switch", "Show symbol"),
    "data-testid": "SymbolSelector.symbolShow.switch",
    checked: (_chartItem$symbol = chartItem.symbol) == null ? void 0 : _chartItem$symbol.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].symbol.show",
          value: el.props.chartItems.props[itemIndex].symbol.show = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("SymbolSelector.symbolTypes.label", "Types")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "SymbolSelector.symbolTypes.selector",
    items: [_constants.SYMBOL_CIRCLE, _constants.SYMBOL_RECT, _constants.SYMBOL_ROUND_RECT, _constants.SYMBOL_TRIANGLE, _constants.SYMBOL_DIAMOND, _constants.SYMBOL_PIN, _constants.SYMBOL_ARROW, _constants.SYMBOL_NONE],
    selected: ((_chartItem$symbol2 = chartItem.symbol) == null ? void 0 : _chartItem$symbol2.type) != null ? [chartItem.symbol.type] : [defaultSymbolType],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref) {
      var selected = _ref[0];
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].symbol.type",
          value: el.props.chartItems.props[itemIndex].symbol.type = selected
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("SymbolSelector.symbolSize.label", "Size")
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "SymbolSelector.symbolSize.input",
    min: 0,
    value: (_chartItem$symbol3 = chartItem.symbol) == null ? void 0 : _chartItem$symbol3.size,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].symbol.size",
          value: el.props.chartItems.props[itemIndex].symbol.size = value
        };
      });
    }
  })));
};